const readPublicPremiumEnv = (value: string | undefined) => value?.trim() ?? ''

export function getPaypalClientId() {
  return readPublicPremiumEnv(import.meta.env.VITE_PAYPAL_CLIENT_ID)
}

export function getStripeSupportEmail() {
  return (
    readPublicPremiumEnv(import.meta.env.VITE_STRIPE_SUPPORT_EMAIL) ||
    'info@hanaspeak.com'
  )
}
